import React, { lazy, Suspense } from 'react';

const ForgotPasswordComponent = lazy(() => import('./partial-payment.component'));

const PartialPaymentLazyComponent = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <ForgotPasswordComponent {...props} />
  </Suspense>
);

export default PartialPaymentLazyComponent;
